class CartDrawer extends SlidingDrawer {
  constructor() {
    super();
    this.overlayElement = this.querySelector(".js-cart-overlay");
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.closeDrawer()
    );

    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.closeDrawer.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    this.openCartOnUrlParams();

    this.addedMessageElement = document.createElement("span");
    this.addedMessageElement.id = "CartDrawer-AddedMessage";
    this.addedMessageElement.className = "visually-hidden";
    this.addedMessageElement.setAttribute("role", "alert");
    this.drawerElement.appendChild(this.addedMessageElement);
  }
  openCartOnUrlParams() {
    if (!window.URLSearchParams) {
      console.warn("does not work in IE11");
      return;
    }

    const searchParams = new window.URLSearchParams(window.location.search);

    if (searchParams.get("cart") === "open") {
      this.openDrawer();
    }
  }
  setHeaderCartIconAccessibility() {
    // const cartLink = document.querySelector("#cart-icon");
    // cartLink.setAttribute("role", "button");
    // cartLink.setAttribute("aria-haspopup", "dialog");
    // cartLink.addEventListener("keydown", (event) => {
    //   if (event.code.toUpperCase() === "SPACE") {
    //     event.preventDefault();
    //     this.open(cartLink);
    //   }
    // });
  }
  bindEvents() {
    document.querySelector(".js-cart-drawer-toggle").addEventListener(
      "click",
      this.onDrawerToggleClick.bind(this)
    );
  }

  openDrawer() {
    const wasOpen = this.drawerElement.classList.contains("drawer--open");
    const opener = document.activeElement;

    if (!wasOpen && opener && opener !== document.body && !this.drawerElement.contains(opener)) {
      this.activeElement = opener;
    }

    setTimeout(() => {
      this.drawerToggle.classList.add("drawer-opening");
    });
    if (!this.drawerElement.contains(this.addedMessageElement)) {
      this.drawerElement.appendChild(this.addedMessageElement);
    }

    this.drawerToggle.setAttribute("aria-expanded", true);
    document.querySelector(".js-cart-drawer-toggle")?.setAttribute("aria-expanded", true);
    this.drawerElement.removeAttribute('inert');
    this.setAttribute("data-open", "");
    this.drawerElement.classList.add("drawer--open");
    this.overlayElement.classList.add("drawer--open");

      // Enable tabbing only on elements inside the drawer
      enableTabbing(this.drawerElement);

    // Apply focus trap
    const keepFocus = wasOpen && this.drawerElement.contains(document.activeElement);
    if (!keepFocus) this.drawerElement.focus({ preventScroll: true });
    trapFocus(this.drawerElement, this.drawerElement.contains(document.activeElement) ? document.activeElement : this.drawerElement);
    if (document.activeElement === this.drawerElement && typeof trapFocusHandlers !== "undefined" && trapFocusHandlers.keydown) {
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    }
    document.body.classList.add("overflow-hidden");
    document.body.classList.add("mini-cart-open");

    this.announceAddedMessage();
  }

  announceAddedMessage() {
    if (!this.pendingAddedMessage || !this.addedMessageElement) return;

    const message = this.pendingAddedMessage;
    this.pendingAddedMessage = null;
    clearTimeout(this.addedMessageTimer);
    this.addedMessageTimer = setTimeout(() => {
      this.addedMessageElement.textContent = message;
    }, 600);
  }

  closeDrawer() {
    const wasOpen = this.drawerElement.classList.contains("drawer--open");
    this.drawerElement.classList.remove("drawer--open");
    this.overlayElement.classList.remove("drawer--open");
    this.drawerToggle.classList.remove("drawer-opening");
    this.drawerToggle.setAttribute("aria-expanded", false);
    document.querySelector(".js-cart-drawer-toggle")?.setAttribute("aria-expanded", false);
    this.drawerElement.setAttribute('inert', '');
    this.resetAddedMessage();
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('mini-cart-open');

      // Disable tabbing on elements inside the drawer
    disableTabbing(this.drawerElement);

    // remove trap focus
    const returnFocusTo = this.activeElement?.isConnected && !this.activeElement.disabled && !this.drawerElement.contains(this.activeElement)
      ? this.activeElement
      : document.querySelector(".js-cart-drawer-toggle");
    removeTrapFocus();
    if (wasOpen) returnFocusTo?.focus({ preventScroll: true });
    this.activeElement = null;

    this.closeAnimation();
  }

  onFocusOut() {}

  renderContents(parsedState) {
    this.querySelector(".js-cart-drawer-inner").classList.contains(
      "is-empty"
    ) &&
      this.querySelector(".js-cart-drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.setAddedMessage(parsedState);
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.closeDrawer.bind(this)
      );
      this.openDrawer();
    });
  }

  resetAddedMessage() {
    clearTimeout(this.addedMessageTimer);
    this.pendingAddedMessage = null;
    if (this.addedMessageElement) this.addedMessageElement.textContent = "";
  }

  setAddedMessage(parsedState) {
    try {
      this.resetAddedMessage();
      if (!parsedState || typeof parsedState !== "object" || !this.addedMessageElement) return;

      const addedItems = parsedState.product_title
        ? [parsedState]
        : parsedState.item_count === undefined && Array.isArray(parsedState.items)
        ? parsedState.items
        : [];
      const titles = [...new Set(addedItems.map((item) => item?.product_title).filter(Boolean))];
      if (titles.length === 0) return;

      const template = this.drawerElement.dataset.addedText || "[product] added to your cart";
      this.pendingAddedMessage = template.replace("[product]", () => titles.join(", "));
    } catch (error) {
      console.warn("[cart-drawer] added message failed", error);
    }
  }

  async renderContentsSilent() {
    const sectionsToRender = this.getSectionsToRender();
    const sectionIds = sectionsToRender.map((section) => section.id);

    try {
      const response = await fetch("/?sections=" + sectionIds.join(","), {
        cache: "no-store",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) return;
      const sections = await response.json();

      sectionsToRender.forEach((section) => {
        const target = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        const html = sections[section.id];
        if (!target || !html) return;
        target.innerHTML = this.getSectionInnerHTML(html, section.selector);
      });

      // Sync `is-empty` class on the wrapper elements with the freshly-
      // rendered state. The empty-state markup contains
      // `.js-cart-drawer-inner-empty`, so its presence indicates an empty cart.
      const inner = this.querySelector(".js-cart-drawer-inner");
      if (inner) {
        const isEmpty = !!inner.querySelector(".js-cart-drawer-inner-empty");
        inner.classList.toggle("is-empty", isEmpty);
        this.classList.toggle("is-empty", isEmpty);
      }

      // If bfcache captured an open drawer, close it — the user opened it on
      // a different page, not the one they're returning to.
      if (this.drawerElement && this.drawerElement.classList.contains("drawer--open")) {
        this.closeDrawer();
      }
    } catch (err) {
      console.warn("[cart-drawer] silent refresh failed", err);
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".js-cart-drawer-inner",
      },
      {
        id: "cart-icon",
        section: "cart-icon",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);


// Refresh cart drawer + cart icon when the browser replays a cached snapshot
// on back/forward navigation (bfcache or HTTP cache). Cart state isn't part
// of the captured DOM, so without this the user sees a stale minicart.
window.addEventListener("pageshow", (event) => {
  const nav = performance.getEntriesByType("navigation")[0];
  const fromCache =
    event.persisted ||
    (nav && nav.type === "back_forward" && nav.transferSize === 0);
  if (!fromCache) return;

  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) cartDrawer.renderContentsSilent();
});

//custom Mod Bundles add to cart
document.addEventListener("cart:updated", async (event) => {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const sectionsToRender = cartDrawer.getSectionsToRender().map((section) => section.id);
  const sectionsUrl = window.location.pathname;

  try {
    const response = await fetch("/?sections=" + sectionsToRender.join(","), {
      headers: {
        "X-Requested-With": "XMLHttpRequest"
      }
    });

    const data = await response.json();

    // Re-render cart drawer contents
    if (event.detail?.opener) cartDrawer.setActiveElement(event.detail.opener);

    cartDrawer.renderContents({
      id: 'cart',
      sections: data,
      sectionsUrl: sectionsUrl,
      items: event.detail?.items
    });

    // Poll for the button to reappear and click it
    const openDrawerWhenReady = () => {
      const trigger = document.querySelector('[aria-controls="CartDrawer"]');
      if (trigger) {
        trigger.click();
      } else {
        requestAnimationFrame(openDrawerWhenReady);
      }
    };

    openDrawerWhenReady();

  } catch (err) {
    console.error("Cart drawer update + open failed:", err);
  }
});
/**
 * @class CartProgress
 * @extends HTMLElement
 *
 * Free-shipping progress bar. Remembers the last value it showed (across
 * re-renders and page loads) and only animates when that value changes,
 * gliding from the previous position once the bar is actually on screen.
 */
const CART_PROGRESS_STORAGE_KEY = "cart-progress";
let lastCartProgress = null;
// Start value of a move that has not been seen yet. Survives the bar being
// re-rendered again before the drawer opens (e.g. an app adds a gift item).
let unplayedCartProgressFrom = null;

const readStoredCartProgress = () => {
  try {
    const value = sessionStorage.getItem(CART_PROGRESS_STORAGE_KEY);
    return value === null ? null : Number(value);
  } catch {
    return null;
  }
};

const storeCartProgress = (value) => {
  lastCartProgress = value;
  try {
    sessionStorage.setItem(CART_PROGRESS_STORAGE_KEY, String(value));
  } catch {}
};

class CartProgress extends HTMLElement {
  connectedCallback() {
    this.fill = this.querySelector(".cart__progress");
    const to = Number(this.dataset.progress) || 0;
    const from = unplayedCartProgressFrom ?? lastCartProgress ?? readStoredCartProgress();

    storeCartProgress(to);

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!this.fill || from === null || from === to || reduceMotion) {
      unplayedCartProgressFrom = null;
      return;
    }

    unplayedCartProgressFrom = from;
    this.fill.style.setProperty("--progress", `${from}%`);

    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      this.observer.disconnect();
      this.play(from, to);
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  play(from, to) {
    unplayedCartProgressFrom = null;
    const clip = (value) => `inset(0 ${100 - value}% 0 0 round 500px)`;

    this.fill.style.setProperty("--progress", `${to}%`);
    this.fill.animate([{ clipPath: clip(from) }, { clipPath: clip(to) }], {
      duration: 900,
      easing: "cubic-bezier(0.22, 1, 0.36, 1)"
    });

    if (to > from) {
      this.classList.add(to >= 100 ? "is-complete" : "is-advancing");
    }
  }
}

if (!customElements.get("cart-progress")) {
  customElements.define("cart-progress", CartProgress);
}
